import type { PaddingOptions } from "maplibre-gl";

export function getMapFitPadding(
  container: HTMLElement,
  minimum = 40,
): PaddingOptions {
  const padding = { top: minimum, bottom: minimum, left: minimum, right: minimum };
  const viewport = container.closest("[data-map-viewport]");
  if (!viewport) return padding;

  const map = container.getBoundingClientRect();
  // Measure at fit time so collapsed panels and the current header height are respected.
  viewport.querySelectorAll<HTMLElement>("[data-map-overlay]").forEach((overlay) => {
    const rect = overlay.getBoundingClientRect();
    if (
      !rect.width ||
      !rect.height ||
      rect.right <= map.left ||
      rect.left >= map.right ||
      rect.bottom <= map.top ||
      rect.top >= map.bottom
    ) return;

    const gap = 24;
    switch (overlay.dataset.mapOverlay) {
      case "left":
        padding.left = Math.max(padding.left, rect.right - map.left + gap);
        break;
      case "right":
        padding.right = Math.max(padding.right, map.right - rect.left + gap);
        break;
      case "top":
        padding.top = Math.max(padding.top, rect.bottom - map.top + gap);
        break;
    }
  });

  // Keep fitBounds valid even when the panels leave almost no space on a narrow screen.
  const horizontalScale = Math.min(
    1,
    Math.max(0, map.width - 64) / Math.max(1, padding.left + padding.right),
  );
  const verticalScale = Math.min(
    1,
    Math.max(0, map.height - 64) / Math.max(1, padding.top + padding.bottom),
  );
  padding.left *= horizontalScale;
  padding.right *= horizontalScale;
  padding.top *= verticalScale;
  padding.bottom *= verticalScale;
  return padding;
}
